export default __webpack_public_path__ + "static/media/lacasitachaupin.36a2ec65.JPG";